import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

const usersTimezone = dayjs.tz.guess();

export const useTimezones = () => {
  const today = dayjs();

  const usersTime = () => {
    return today.tz(usersTimezone);
  };

  const usersTimezoneName = (formatted: boolean) => {
    if (formatted) {
      return usersTimezone.toString().split('/')[1];
    }

    return usersTimezone;
  };

  const timeZoneForState = (state: string | null | undefined) => {
    switch (state) {
      case "NSW":
      case "ACT":
        return "Australia/Sydney";
      case "VIC":
        return "Australia/Melbourne";
      case "QLD":
        return "Australia/Brisbane";
      case "SA":
        return "Australia/Adelaide";
      case "WA":
        return "Australia/Perth";
      case "TAS":
        return "Australia/Hobart";
      case "NT":
        return "Australia/Darwin";
      default:
        return "Australia/Sydney";
    }
  };

  const convertDateToUserRegion = (time: string | null | undefined, region: string | null | undefined): Dayjs | null => {
    try {
      const regionTimezone = timeZoneForState(region);
      let parsedTime = dayjs();
      if (time && time.includes('-'))
        parsedTime = dayjs.tz(time, 'YYYY-MM-DD HH:mm', 'Australia/Sydney').utc();
      else
        parsedTime = dayjs.tz(time, 'DD/MM/YYYY HH:mm', 'Australia/Sydney').utc();
      return parsedTime.tz(regionTimezone, false);
    } catch (e) {
      console.log('Error converting date', time, e);
      return null;
    }
  };

  // This is used specifically for formats in the database that are poorly managed and lack timezone info. Don't use on properly formatted iso dates.
  const convertDateToUser = (time: string | null | undefined): Dayjs | null => {
    try {
      let parsedTime = dayjs();
      if (time && time.includes('-'))
        parsedTime = dayjs.tz(time, 'YYYY-MM-DD HH:mm', 'Australia/Sydney').utc();
      else
        parsedTime = dayjs.tz(time, 'DD/MM/YYYY HH:mm', 'Australia/Sydney').utc();
      return parsedTime.tz(usersTimezone, false);
    } catch (e) {
      console.log('Error converting date', time, e);
      return null;
    }
  };

  const convertUTCDateToUserISO = (time: string | null | Dayjs | undefined): Dayjs | null => {
    try {
      const parsedTime = dayjs(time).utc().tz(usersTimezone);

      return parsedTime;
    } catch (e) {
      return null;
    }
  };

  const formatDateToUser = (date: string | null | undefined): string => {
    if (!date) return '';

    const convertedTime = convertUTCDateToUserISO(date);

    if (!convertedTime?.isValid()) return '';

    return convertedTime?.format('DD/MM/YYYY') ?? '';
  };

  const brisbaneTime = (): Dayjs => {
    const parsedTime = dayjs().utc().tz('Australia/Brisbane');

    return parsedTime;
  };

  const sydneyTime = (): Dayjs => {
    const parsedTime = dayjs().utc().tz('Australia/Sydney');

    return parsedTime;
  };

  return {
    formatDateToUser,
    usersTimezone,
    usersTimezoneName,
    convertDateToUserRegion,
    convertUTCDateToUserISO,
    convertDateToUser,
    brisbaneTime,
    sydneyTime,
    today,
    usersTime,
  };
};
